import { PersonAddAlt1 } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { CreateUserDialog } from "./CreateUserDialog";

interface Props {
  refreshList: () => void;
}

export function CreateUserButton({ refreshList }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Crear nuevo usuario">
        <IconButton
          color="primary"
          onClick={() => setOpen(true)}
          sx={{
            backgroundColor: "#00C853",
            color: "white",
            borderRadius: 2,
            "&:hover": { backgroundColor: "#00b048" },
          }}
        >
          <PersonAddAlt1 />
        </IconButton>
      </Tooltip>

      <CreateUserDialog
        open={open}
        onClose={() => setOpen(false)}
        refreshList={refreshList}
      />
    </>
  );
}
